import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/idp-ai.png'
import _imports_1 from '@/assets/img/home/swiperbanner3.png'
import _imports_2 from '@/assets/img/home/GPUpisition.png'
import _imports_3 from '../assets/img/home/1.2.1数据科学家.png'
import _imports_4 from '../assets/img/home/1.2.2算法工程师.png'
import _imports_5 from '../assets/img/home/1.2.3大数据工程师.png'
import _imports_6 from '../assets/img/home/1.2.4业务分析师.png'
import _imports_7 from '../assets/img/home/gpuaas-heng.png'
import _imports_8 from '../assets/img/home/mlops-heng.png'
import _imports_9 from '../assets/img/home/maas-heng.png'
import _imports_10 from '../assets/img/home/asdbase.png'
import _imports_11 from '../assets/img/home/1.6.1icon行业洞见.png'
import _imports_12 from '../assets/img/home/形状结合@2x.png'
import _imports_13 from '../assets/img/home/1.6.2开源社区.png'
import _imports_14 from '../assets/img/home/1.6.3IDP文档.png'


const _withScopeId = n => (_pushScopeId("data-v-3a686fff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-banner banner bannerno" }
const _hoisted_3 = { class: "warp outer-package" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "swiper-img",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "a global-title pdt" }, [
  /*#__PURE__*/_createElementVNode("span", null, "IDP"),
  /*#__PURE__*/_createElementVNode("span", null, " ( Intelligent Development Platform ) ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b global-title" }, "让AI更简单·更快速·更高效", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c global-title" }, "AI与专属可控大模型应用加速平台", -1))
const _hoisted_8 = { class: "d global-title" }
const _hoisted_9 = { class: "warp outer-package" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "swiper-img",
  src: _imports_1,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "a global-title pdt" }, [
  /*#__PURE__*/_createElementVNode("span", null, "IMC白聚易")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b global-title" }, "类营销传播专家多模态", -1))
const _hoisted_13 = { class: "d global-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warp outer-package" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "swiper-img",
    src: _imports_2,
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "a global-title pdt" }),
  /*#__PURE__*/_createElementVNode("div", { class: "b global-title" }, "白海AI市场"),
  /*#__PURE__*/_createElementVNode("div", { class: "c global-title" }, "模型开放市场，发现并即刻体验适合每个项目的创新方案")
], -1))
const _hoisted_15 = { class: "home-two outer-package" }
const _hoisted_16 = { class: "home-title outer-package" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, [
  /*#__PURE__*/_createElementVNode("p", null, "数据科学家"),
  /*#__PURE__*/_createElementVNode("p", null, "立即试用")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, [
  /*#__PURE__*/_createElementVNode("p", null, "算法工程师"),
  /*#__PURE__*/_createElementVNode("p", null, "立即试用")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, [
  /*#__PURE__*/_createElementVNode("p", null, "大数据工程师"),
  /*#__PURE__*/_createElementVNode("p", null, "立即试用")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })
], -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, [
  /*#__PURE__*/_createElementVNode("p", null, "业务分析师"),
  /*#__PURE__*/_createElementVNode("p", null, "立即试用")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-3a686fff><div class=\"global-title\" data-v-3a686fff>产品生态</div><p data-v-3a686fff>AI训推云平台IDP，旨在为企业和机构提供从计算资源、模型构建、模型服务于一体</p><p data-v-3a686fff>的平台解决方案，帮助客户低门槛、高效率地落地专属AI及大模型应用</p></div><div data-v-3a686fff><div style=\"position:relative;\" data-v-3a686fff><img class=\"img1\" src=\"" + _imports_7 + "\" alt=\"\" data-v-3a686fff><img class=\"img2\" style=\"\" src=\"" + _imports_8 + "\" alt=\"\" data-v-3a686fff><img class=\"img3\" src=\"" + _imports_9 + "\" alt=\"\" data-v-3a686fff><img style=\"width:789px;margin:0 auto;margin-top:96px;display:block;\" src=\"" + _imports_10 + "\" alt=\"\" data-v-3a686fff><div class=\"teble\" data-v-3a686fff><div class=\"tab\" data-v-3a686fff> 高性价比的<br data-v-3a686fff> 算力资源 </div><div class=\"tab\" data-v-3a686fff> 稳定易用的<br data-v-3a686fff> AI训推工具平台 </div><div class=\"tab\" data-v-3a686fff> 开发效率<br data-v-3a686fff> 提升40% </div><div class=\"tab\" data-v-3a686fff> 集群资源利用率<br data-v-3a686fff> 提升30% </div></div></div></div>", 2)
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-three" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "outer-package characteristic" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title global-title" }, [
      /*#__PURE__*/_createElementVNode("div", null, "易用"),
      /*#__PURE__*/_createElementVNode("div", null, "性能"),
      /*#__PURE__*/_createElementVNode("div", null, "协同")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "txt" }, [
      /*#__PURE__*/_createElementVNode("div", null, "一站式低门槛完成专属大模型构建和AI开发生产全流程，促进大模型和AI平民化 ；模块解耦，客户可按需组合所需功能， 轻量便捷"),
      /*#__PURE__*/_createElementVNode("div", null, "自研高性能调度与分布式计算引擎，进行task级别任务调度，提高吞吐量，提升分布式计算性能和效率；支持运行中的断点续跑和自动休眠"),
      /*#__PURE__*/_createElementVNode("div", null, "与业务高效协同，便捷整合客户数据、业务系统等，根据业务反馈持续升级模型；标准化沉淀与共享组织内的AI资产，提升模型落地和业务响应速度")
    ])
  ])
], -1))
const _hoisted_32 = { class: "home-five outer-package" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "global-title title" }, "进一步了解一下吧", -1))
const _hoisted_34 = { class: "five-three" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "行业洞见     ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_12 })
], -1))
const _hoisted_38 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "IDP 开源社区     ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_12 })
], -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: _imports_14,
  alt: ""
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "IDP 文档     ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_12 })
], -1))
const _hoisted_46 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ProductUsers = _resolveComponent("ProductUsers")!
  const _component_SecondFooter = _resolveComponent("SecondFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_swiper, {
        modules: "",
        pagination: { clickable: true },
        onSwiper: _ctx.onSwiper,
        loop: "",
        autoplay: true,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
        style: {"height":"640px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "e btn-animation1",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routGo('https://idp.baihai.co/login')))
                  }, "申请试用"),
                  _createElementVNode("button", {
                    class: "f btn-animation2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkGo('https://www.bilibili.com/video/BV1Ja411o7to')))
                  }, "观看Demo")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "e btn-animation1",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openUrl('http://imcgpt.baihai.co:9997/information')))
                  }, "申请试用")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSwiper", "navigation"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "home-item btn-animation4",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.routGo('/information')))
        }, _hoisted_19),
        _createElementVNode("div", {
          class: "home-item btn-animation4",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.routGo('/information')))
        }, _hoisted_22),
        _createElementVNode("div", {
          class: "home-item btn-animation4",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.routGo('/information')))
        }, _hoisted_25),
        _createElementVNode("div", {
          class: "home-item btn-animation4",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.routGo('/information')))
        }, _hoisted_28)
      ]),
      _hoisted_29
    ]),
    _hoisted_31,
    _createVNode(_component_ProductUsers),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", {
          class: "ft-div btn-animation4",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.linkGo('https://www.zhihu.com/column/c_1465275278654500864')))
        }, _hoisted_38),
        _createElementVNode("div", {
          class: "ft-div btn-animation4",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.linkGo('https://github.com/BaihaiAI/IDP')))
        }, _hoisted_42),
        _createElementVNode("div", {
          class: "ft-div btn-animation4",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.linkGo('https://www.yuque.com/baihai_idp/kencft?#')))
        }, _hoisted_46)
      ])
    ]),
    _createVNode(_component_SecondFooter)
  ]))
}